import React from 'react';
import './shared.css';
import Footer from './Footer';
import TopNav from './TopNav';

function PrivacyPolicy() {
  return (
    <div className="min-h-screen w-full bg-gray-50">
      {/* Top Navigation */}
      <TopNav />

      {/* Header Section */}
      <div className="App-header" style={{ background: '#1f2937', minHeight: '20vh' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '1rem', textAlign: 'center' }}>
          Privacy Policy
        </h1>
      </div>

      {/* Main Content */}
      <div className="responsive-px" style={{ paddingTop: '2rem', paddingBottom: '2rem', maxWidth: '900px', margin: '0 auto' }}>
        <div style={{ fontSize: '1rem', lineHeight: 1.8, color: '#374151' }}>
          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>1. Information We Collect</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            PotatoPapers uses browser localStorage to store your preference for showing grade boundaries. We also use Google Analytics to understand how visitors use the site. Google Analytics may collect data such as pages visited, time spent, device information, and referral sources. No personally identifiable information is collected or stored on our servers.
          </p>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>2. How We Use Information</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            The localStorage setting is used solely to remember your viewing preference (show/hide grade boundaries) when you return to the site. This data never leaves your device.
          </p>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>3. Data Security</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            Since no data is transmitted to our servers, there is no risk of data breach on our end. Your localStorage is protected by your browser's security mechanisms.
          </p>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>4. Third-Party Links</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            This site links to YouTube videos hosted by external creators. Please review YouTube's privacy policy for information about how they handle your data.
          </p>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>5. Google Analytics</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            We use Google Analytics to monitor site performance and understand how users interact with the site. Google Analytics collects anonymous data about your visit. This data does not identify you personally and is used only to improve our service.
          </p>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>6. Data Sharing</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            We do not sell or share your data with third parties, except for Google Analytics as described above. Google's use of data is governed by their privacy policy.
          </p>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>7. Changes to This Policy</h2>
          <p style={{ marginBottom: '1.5rem' }}>
            We may update this policy at any time. Changes will be posted on this page.
          </p>

          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1f2937' }}>8. Contact</h2>
          <p>
            If you have questions about this privacy policy, please reach out through the site.
          </p>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
